import CourseCard, {
  SizeOptions as _SizeOptions,
  Course as _Course
} from './CourseCard';
export default CourseCard;
export type SizeOptions = _SizeOptions;
export type Course = _Course;
